// Ajustes > Atualizações e sobre (0.67, texto 05 D3): versão do app e da atualização e "Procurar atualização agora"
// (vieram da antiga "Configuração geral" e do rodapé da capa).
import { Platform, Text } from 'react-native';
import * as Updates from 'expo-updates';
import { AtualizacaoBanner } from '../../components/AtualizacaoBanner';
import { C } from '../../components/theme';
import { descricaoVersao, procurarAtualizacoes, useAtualizacao, versaoApp, versaoCurta } from '../../lib/atualizacoes';
import { brDateTime } from '../../lib/date';
import { Recolhivel } from '../../components/Recolhivel';
import { t } from '../../lib/i18n';
import { Card, Linha } from './comum';
import { BotaoAcao, Bloco } from '../../components/ajustes/Linhas';
import { QuadroServidor, ehDonoDoServidor } from '../../components/ajustes/QuadroServidor';
import { useAuth } from '../../auth/AuthContext';

/** Detalhes técnicos (para o suporte): app instalado, pacote de atualização, canal e identificação. Fica recolhido. */
function DetalhesTecnicos() {
  const linhas: [string, string][] = [
    [t('App instalado'), versaoApp()],
    [t('Pacote em uso'), descricaoVersao()],
  ];
  if (Platform.OS !== 'web') {
    linhas.push([t('Origem'), !Updates.isEnabled || Updates.isEmbeddedLaunch ? t('o que veio com a instalação') : t('atualização automática')]);
    if (Updates.createdAt) linhas.push([t('Publicado em'), brDateTime(Updates.createdAt.toISOString())]);
    if (Updates.runtimeVersion) linhas.push(['Runtime', String(Updates.runtimeVersion)]);
    if (Updates.channel) linhas.push([t('Canal'), String(Updates.channel)]);
    if (Updates.updateId) linhas.push([t('Identificação'), String(Updates.updateId)]);
  }
  return (
    <Recolhivel titulo={t('Detalhes técnicos')} chave="sobre-detalhes">
      {linhas.map(([l, v]) => (
        <Linha key={l} l={l}><Text style={{ color: C.sub, fontSize: 12, flexShrink: 1, textAlign: 'right' }} selectable>{v}</Text></Linha>
      ))}
    </Recolhivel>
  );
}

export default function Sobre({ cor }: { cor: string }) {
  const atu = useAtualizacao();
  const { cpf } = useAuth();
  const versao = t('Versão {v}', { v: versaoCurta() });
  return (<>
    {Platform.OS !== 'web' ? (
      <Bloco titulo={t('Atualizações')}>
        <Card>
          <Text style={{ color: C.text, fontWeight: '700', fontSize: 15 }}>{versao}</Text>
          <Text style={{ color: atu.ota === 'erro' ? C.warn : C.sub, fontSize: 12 }}>
            {atu.ota === 'desligado' ? t('Atualização automática disponível no app instalado.')
              : atu.ota === 'procurando' ? t('Procurando atualização...') : atu.ota === 'baixando' ? t('Baixando atualização...')
              : atu.ota === 'pronta' ? t('Atualização baixada. Entra ao reabrir o app ou ao tocar no aviso.')
              : atu.ota === 'erro' ? t('Não foi possível procurar agora. Tenta de novo sozinho mais tarde.')
              : t('Em dia. As melhorias chegam sozinhas quando o app abre.')}
          </Text>
          <AtualizacaoBanner cor={cor} />
          <BotaoAcao cor={cor} label={t('Procurar atualização agora')} onPress={() => procurarAtualizacoes(true)} />
          <DetalhesTecnicos />
        </Card>
      </Bloco>
    ) : (
      <Card><Text style={{ color: C.text, fontWeight: '700', fontSize: 15 }}>{versao}</Text><DetalhesTecnicos /></Card>
    )}
    {ehDonoDoServidor(cpf) && <QuadroServidor cor={cor} />}
    <Text style={{ color: C.mute, textAlign: 'center', fontSize: 11, marginTop: 10 }}>My Planner Anne · {versao}</Text>
    <Text style={{ color: C.mute, textAlign: 'center', fontSize: 10 }}>© 2026 Byah Ravasco</Text>
  </>);
}
